import React from "react";
// eslint-disable-next-line import/named
import { Control, useWatch } from "react-hook-form";
import { drawingCodeConflictMessage } from "../../services/drawingCodes";
import { ErrorMessage } from "../ErrorMessage/ErrorMessage";

export interface DrawingCodeWarningProps {
  // only organizations with drawings get the warning
  enabled: boolean;
  control: Control;
  nameField: string;
  codeField: string;
  defaultName?: string | null;
  defaultCode?: string | null;
}

// split out so the watching only happens when the warning can show
const Warning: React.FC<Omit<DrawingCodeWarningProps, "enabled">> = ({
  control,
  nameField,
  codeField,
  defaultName,
  defaultCode,
}) => {
  const name = useWatch<string>({
    control,
    name: nameField,
    defaultValue: defaultName || "",
  });
  const code = useWatch<string>({
    control,
    name: codeField,
    defaultValue: defaultCode || "",
  });

  return <ErrorMessage error={drawingCodeConflictMessage(name, code)} />;
};

/**
 * Warns, without blocking saving, when a line names more than one drawing
 * - a code in its name and a different Item code, or several codes in its
 * name - so the drawing search would skip it.
 */
export const DrawingCodeWarning: React.FC<DrawingCodeWarningProps> = ({
  enabled,
  ...props
}) => (enabled ? <Warning {...props} /> : null);
